<nav class="navbar navbar-expand-md navbar-light navbar_page">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav"
    aria-expanded="false" aria-label="Toggle navigation" (click)="isNavbarCollapsed = !isNavbarCollapsed">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" [ngClass]="{ 'show': !isNavbarCollapsed }" id="navbarNav">
    <ul class="navbar-nav">
      <!-- <li class="nav-item" [routerLinkActive]="'active'">
        <a class="nav-link" [routerLink]='["/consumer/central-hub"]'>{{ "general.Home" | translate }}</a>
      </li> -->
      <ng-container *ngFor="let item of nav.menuList">
        <li class="nav-item" [routerLinkActive]="'active'">
          <a class="nav-link" [routerLink]="item.route">
            {{item.title}}
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
</nav>

<div class="container">
  <router-outlet (activate)="onOutletLoaded($event)"></router-outlet>
</div>
